import styles from './styles.module.scss';

export const Button = ({
  title,
  onClick,
  type = 'button',
  theme = 'default',
  disabled = false,
  style = {},
  'data-testid': dataTestId,
}: {
  title?: string;
  onClick?: (event?: React.MouseEvent<HTMLButtonElement>) => void;
  type?: 'button' | 'submit';
  theme?: 'default' | 'red' | 'blue';
  style?: React.CSSProperties;
  disabled?: boolean;
  'data-testid'?: string;
}) => {
  return (
    <button
      className={styles.Root}
      onClick={onClick}
      style={style}
      type={type}
      disabled={disabled}
      data-theme={theme}
      data-testid={dataTestId}
    >
      {title}
    </button>
  );
};
